module.exports = {
	ENV: 'PROD',
	URL: '/api/',
	API: 'v2/',
	SOCKET: 'https://power.upsales.com',
	PUBLICPATH: 'https://img.upsales.com/',
	FORMPATH: 'http://resource.upsales.com/forms/',
	LANDINGPAGEPATH: 'https://pages.upsales.com',
	CLASSIC_URL: 'https://crm.upsales.com/professional/application/',
	STATIC_MAPS_KEY: 'AIzaSyBz8DCi-zXpKspt_-LTIlhu-0vbLYMTNOA',
	GOOGLE_FONTS_KEY: 'AIzaSyDRwD9bJV8XncXBSWG9SQxM0sHHPso5rbw',
	STATUSPAGE: {
		componentId: '1gr032v9zz1j'
	},
	PUSHER: {
		key: '0dae677b9a6736e36932',
		cluster: 'mt1'
	},
	SENTRY: {
		enable: true,
		env: 'production',
		dsn: 'https://47d0330c417c4f02b0da97429871724c@sentry.upsales.com/3',
		allowUrls: [/https?:\/\/((static|power)\.)?upsales\.com/],
		denyUrls: [/https?:\/\/static.upsales.com\/ckeditor\/.*\/ckeditor.js/]
	},
	PARAGON: {
		projectId: 'f26eea68-5c3d-4ecd-894b-669bec28db35',
		endpoint: 'https://zeus.paragon.upsales.com/projects',
		host: 'paragon.upsales.com',
		workerProxyPublicUrl: 'https://worker-proxy.paragon.upsales.com',
		custom: {
			1001309: '397c6e88-b18e-4c73-9b17-4769a79d9028',
			1001484: '6ee39a51-9ce6-492a-a0db-103c76703d9c',
			15882: 'd0e53c81-42ae-4ebf-89a2-6d890ceec21e'
		}
	},
	CHECKIN_URL: 'https://checkin.upsales.com/',
	CUSTOM_DOMAIN_CNAME: 'domain.upsales.com',
	STATIC_URL: 'https://static.upsales.com/**',
	SPLIT_KEY: 'ddq3h6eiumsifs3ds5m0gnt9u4lj16r7s1aq',
	chatEnabled: true,
	GOOGLE_MAPS_KEY: 'AIzaSyBz8DCi-zXpKspt_-LTIlhu-0vbLYMTNOA',
	GOOGLE_MAPS_UPSALES_MAP_ID: 'df76eaf7634c8288',
	WORKFLOW_URL: 'https://agents.upsales.com',
	MAPBOX_TOKEN: 'pk.eyJ1IjoiZHdpa2JlcmciLCJhIjoiY21mbTd3M3ptMDVibDJscGUxeXJleXdxMyJ9.CyAyfqsNHZCYESUvc4iBug'
};
